/* eslint-disable react/jsx-key */
import React, {useEffect, useState, useRef } from 'react';
import {Route, Switch, NavLink} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import Dashboard from '../dashboard/Dashboard';
import {StyledButtonBack, StyledReactSVG, Text} from '../Pages.style';
import backIcon from '../../assets/images/icons/chevron-left-solid.svg';
import { Spin } from 'antd';
import {
    SheetRow,
    FooterContainer,
    TextFooter,
    Container,
    Title,
    Wrapper,
    FixedColumn,
    ScrollableWrapper,
    Table,
    Tbody,
    TbodyNames,
    Td,
    TdNames,
    HoursShiftDiv,
    ObligationDiv,
    HourLabelsCell,
    HourTicksCell,
    HourTick,
    HalfHourTick,
    HourCaptionWrapper,
    HourCaption,
    FirstHourCaption,
    TwoHoursCellContainer,
    BottomLine
} from './DailyPlan.style';
import {useAuthStateValue} from '../../context/AuthContext';
import useDailyPlan from './hooks/dailyPlan';
import {ReactSVG} from 'react-svg';
import faceFrown from '../../assets/images/icons/face-meh-solid.svg';

const DailyPlan = () => {

    const {t} = useTranslation();
    const [year, setYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const presentMonth = new Date().getMonth() + 1;
    const {loggedUser} = useAuthStateValue();

    const capitalizeFirstLetter = (word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      };

    const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
    const today = new Date();
    const timezoneOffset = today.getTimezoneOffset(); // Returns the offset in minutes from GMT (UTC)
    const isDST = timezoneOffset < 120; // Bosnia is UTC+1 during winter and UTC+2 during summer, so check for DST
    let dateString = today.toLocaleDateString('sr-Latn-BA', options);
    const yearToday = today.getFullYear();
    const monthToday = today.getMonth() + 1;
    const dayToday = today.getDate();
 
    dateString = dateString.split(' ').map(word => {
      return capitalizeFirstLetter(word);
    }).join(' ');

    const {dataSource, loading, fetchDailyAll} = useDailyPlan({

    });

    useEffect(() => {
      fetchDailyAll();
      }, []);

    const noDailyPlans = t('dailyPlan.noDailyPlansMessage');

    const currentYear = new Date().getFullYear();

    const getDaysInMonth = (year, month) => {
        const days = [];
        const lastDay = new Date(year, month, 0).getDate();
    
        for (let day = 1; day <= lastDay; day++) {
          days.push({
            date: day,
            dayOfWeek: new Date(year, month - 1, day).getDay(),
          });
        }
    
        return days;
      };

    const myList = ['06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', 
        '19', '20', '21', '22', '23', '00', '01', '02', '03', '04', '05', '06'];
   
    const adjustTimeListForDST = (list, isDST) => {
      return list.map(hour => {
          let adjustedHour = parseInt(hour, 10);
          
          if (isDST) {
              // If it's DST, subtract 1 hour
              adjustedHour = (adjustedHour - 1 + 24) % 24; // Ensures 00 becomes 23
          }
    
          // Format hour to always be 2 digits
          return adjustedHour < 10 ? `0${adjustedHour}` : `${adjustedHour}`;
      });
    };
    
    // Apply the adjustment
    const adjustedList = adjustTimeListForDST(myList, isDST);

    const hourCellRef = useRef();

    const dayPeriod = 'ALL';
    const intervals = {
        "morningEarliest": !isDST ? 6 : 5,
        "morningLatest": !isDST ? 17 : 16,
        "noonEarliest": !isDST ? 14 : 13,
        "noonLatest": !isDST ? 22 : 21,
        "nightEarliest": !isDST ? 22 : 21,
        "nightLatest": !isDST ? 6 : 5
    }
  
    let interval;
    let numberOfHours;
    
    if (dayPeriod === 'ALL') {
      numberOfHours = 24 - intervals?.morningEarliest + intervals?.nightLatest;
      interval = [intervals?.morningEarliest, intervals?.nightLatest];
    } else if (dayPeriod === 'MORNING') {
      numberOfHours = intervals?.morningLatest - intervals.morningEarliest;
      interval = [intervals?.morningEarliest, intervals.morningLatest];
    } else if (dayPeriod === 'NOON') {
      numberOfHours = intervals?.noonLatest - intervals?.noonEarliest;
      interval = [intervals?.noonEarliest, intervals?.noonLatest];
    } else if (dayPeriod === 'NIGHT') {
      numberOfHours = 24 - intervals?.nightEarliest + intervals?.nightLatest;
      interval = [intervals?.nightEarliest, intervals.nightLatest];
    }

    const renderHeaderRows = () => {
        const ticksArray = [];
        const hourCaptionsArr = [];
    
        if (!interval) {
          for (let i = 0; i <= 23; i += 1) {
            ticksArray.push(<HourTick ref={i === 0 ? hourCellRef : null}/>);
            hourCaptionsArr.push(
              <HourCaptionWrapper>
                {
                    i === 0 && (
                      <FirstHourCaption>00</FirstHourCaption>
                    )
                  }
                <HourCaption>
                  {i < 23 ? ((i + 1)?.toString()?.length === 1 ? ('0' + (i + 1).toString()) : (i + 1)) : '00'}
                </HourCaption>
              </HourCaptionWrapper>
            );
          }
        } else if (interval) {
          adjustedList?.map((item, i) => {
          //  ticksArray.push(<HourTick><HalfHourTick /></HourTick>);
            hourCaptionsArr.push(
                <HourCaptionWrapper>
                  <HourCaption>
                    {item}
                  </HourCaption>
                </HourCaptionWrapper>
              );
          });
          adjustedList?.slice(0, adjustedList.length - 1).map((item, i) => {
            ticksArray.push(<HourTick><HalfHourTick /></HourTick>);
          });
          
        }
    
        return (
          <>
            <SheetRow style={{ marginLeft: '2px', width: '1068px' }}>
              {/* <VersionCell>
                ver.
                {version}
              </VersionCell> */}
              <TwoHoursCellContainer>
                <HourLabelsCell>
                  {hourCaptionsArr}
                </HourLabelsCell>
                <HourTicksCell>
                  {ticksArray}
                </HourTicksCell>
              </TwoHoursCellContainer>
            </SheetRow>
          </>
        );
    };

    const calculateTimeDifference = (timeFrom, timeTo) => {
      const timeFromDate = new Date(`1970-01-01T${timeFrom}Z`);
      const timeToDate = new Date(`1970-01-01T${timeTo}Z`);
    
      // Check if timeTo is earlier than timeFrom, indicating that it crosses midnight
      if (timeToDate < timeFromDate) {
        // Add 24 hours to timeToDate to account for midnight crossover
        timeToDate.setDate(timeToDate.getDate() + 1);
      }
    
      // Calculate the difference in milliseconds and then convert to hours
      const timeDiffInMs = timeToDate - timeFromDate;
      return timeDiffInMs / (1000 * 60 * 60); // Convert milliseconds to hours
    };

    const checkIfDecimalOrInteger = (number) => {
      return number % 1 === 0;
    }

    const getShiftColors = (shiftType) => {
      // New color scheme
      const colorMap = {
        'L': '#78D59A',
        'LU': '#78D59A',
        'U': '#FFC067',
        'H': '#FF9E99',
        'HT': '#FF9E99',
        'UHT': '#FF9E99',
        'LUHT': '#FF9E99',
        'LUHTS': '#FF9E99',
        'HTS': '#FF9E99',
        'UHTS': '#FF9E99',
        'T': '#8FD9FB',
        'TS': '#8FD9FB',
        'S': '#FFEE8C',
        'FMP': '#cdb1ca',
        'ŠS': '#cdb1ca',
        'ŠS/FMP': '#cdb1ca',
        'SATCO': '#cdb1ca',
        'SB': '#808080',
        'P': '#808080',
        'LUHTS E/P': '#808080'
      };
      
      return colorMap[shiftType] || '#C9C9C9'; 
    };

    const getObligationColors = (sectorRoleShortName) => {
      if (sectorRoleShortName == 'EXE') return '#b51200';
      if (sectorRoleShortName == 'PLC') return '#539441';
      return null;
    };


    return (
        <Container>
            {/* <div className={"loading"+(loading?" shown":" not-shown")}><Spin /></div> */}
            <Title>
                <StyledButtonBack><NavLink to='/'><StyledReactSVG
                    src={backIcon}></StyledReactSVG></NavLink></StyledButtonBack>
                <Text>
                    {t('main.dailyPlan')}</Text>
            </Title>
            <Wrapper style={{marginTop: 50,  overflow:'scroll', marginBottom: '55px', scrollbarWidth: 'none'}}>
              <FixedColumn>
                <Table>
                  <TbodyNames>
                  <div style={{position:'sticky', background:'rgb(230, 230, 230)', zIndex:46, top:-1, height:46}}>
                  <div></div>
                  </div> 
                    {dataSource?.controllers?.map((controller, index) => (
                      <tr key={index}>
                        <TdNames 
                          isShiftManager={controller?.isShiftManager || controller?.isSatco}
                          isStudent={controller?.role === 'STUDENT'}
                        >
                        <div 
                            style={{ position: 'absolute', right: '2px', top: '15px', fontSize: '7px', fontWeight: '600', background: 'white', width: '12px', height: '12px', borderRadius: '7px' }}
                          >
                            {controller?.location}
                          </div>
                          {controller?.firstName}<br />{controller?.lastName?.split(' ').length > 1
                          ? `${controller?.lastName.split(' ')[0][0]}. ${controller?.lastName.split(' ')[1]}`
                          : controller?.lastName}
                        </TdNames>
                      </tr>
                    ))}
                  </TbodyNames>
                </Table>
              </FixedColumn> 

              <ScrollableWrapper>
                <Table>
                  <div 
                    style={{position:'sticky', background:'rgb(230, 230, 230)', zIndex:4, top:0, height:50, marginLeft:10}}
                  >              
                  {renderHeaderRows()}
                  </div> 
                  <Tbody style={{  marginLeft:10}}>
                    {dataSource?.controllerObligations?.map((item, i) => {
                        const calculatedWidthInPx = item?.shift?.duration * 44.43;
                        const hourFrom = parseInt(item?.shift?.timeFrom?.slice(0, 2), 10);
                        const hoursBeforeShift = hourFrom - 6;
                        // const calculatedLeftMarginInPx = hoursBeforeShift * 44.43;
                        const calculatedLeftMarginInPx = isDST ? (hoursBeforeShift * 44.43) + 44.43 : (hoursBeforeShift * 44.43);
                        
                        const firstObligation = item?.obligations?.[0];
                        const sectorShortName = firstObligation?.sector?.shortName;
                        const shiftColor = getShiftColors(sectorShortName);
                        
                        return(
                        <Td>
                          <HoursShiftDiv
                            style={{ width: calculatedWidthInPx, left: calculatedLeftMarginInPx }}
                            shiftColor={shiftColor}
                          > 
                          {item?.obligations?.map((obligation, index) => {
                            const obligationDuration = calculateTimeDifference(obligation?.timeFrom, obligation?.timeTo);
                            const calculatedObligationWidthInPx = obligationDuration * 2  * 22.4;

                            let obligationTimeDifference = calculateTimeDifference(item?.shift?.timeFrom, obligation?.timeFrom);
                            let calculatedLeftMarginObligation;
                            if (checkIfDecimalOrInteger(obligationTimeDifference))
                              calculatedLeftMarginObligation = obligationTimeDifference * 44.43;
                            else
                              calculatedLeftMarginObligation = 22.4 + Math.floor(obligationTimeDifference) * 44.43;
                            
                            return (
                              (obligationDuration < 0.5) ? 
                              <ObligationDiv 
                                sectorRoleShortName={obligation?.sectorRole?.shortName}
                                sectorShortName={obligation?.sector?.shortName}
                                style={{ 
                                  width: calculatedObligationWidthInPx, 
                                  left: calculatedLeftMarginObligation,
                                  display: 'flex'
                                }}
                              >
                                <div style={{ 
                                 // fontSize:'4.9px',
                                  fontSize: '8px',
                                  fontWeight: '600',
                                  overflow: 'hidden', 
                                  writingMode: 'vertical-rl', 
                                  textOrientation: 'upright',
                                   // height: '37px', 
                                  height: '100%',
                                  letterSpacing: obligation?.sector?.shortName?.length <= 3 ? '0px' : '-3.5px'
                                }}>
                                  {obligation?.assignment === 'ASSE' && `${obligation.assignment[0]} `}
                                  {obligation?.assignment === 'OJTI' && `${obligation.assignment[0]} `}
                                  {obligation?.sector?.shortName}
                                </div>
                                <BottomLine backgroundColor={getObligationColors(obligation?.sectorRole?.shortName)} /> 
                                {/* <BottomLine backgroundColor={'red'} />  */}
                              </ObligationDiv> 
                              : 
                              <ObligationDiv 
                                sectorRoleShortName={obligation?.sectorRole?.shortName}
                                sectorShortName={obligation?.sector?.shortName}
                                style={{ 
                                  width: calculatedObligationWidthInPx, 
                                  left: calculatedLeftMarginObligation,
                                  display: 'flex' 
                                }}
                              >
                                <div style={{ 
                                  fontSize: '8px',
                                  fontWeight: '600', 
                                  overflow: 'hidden'
                                }}>
                                  {obligation?.assignment === 'ASSE' && `${obligation.assignment[0]} `}
                                  {obligation?.assignment === 'OJTI' && `${obligation.assignment[0]} `}
                                  {obligation?.sector?.shortName}
                                </div>
                                <BottomLine backgroundColor={getObligationColors(obligation?.sectorRole?.shortName)} />
                              </ObligationDiv> 
                            )})}
                          </HoursShiftDiv>
                        </Td>
                        )                    
                      })}
                  </Tbody>
                </Table>
              </ScrollableWrapper>
            </Wrapper>
            <FooterContainer>
              <TextFooter
                className={((presentMonth === selectedMonth) && (year === currentYear)) ? 'currentMonth' : ''}>
                  {dateString}
              </TextFooter>
            </FooterContainer>
            <Switch>
                <Route path='/' exact component={Dashboard}></Route>
            </Switch>
        </Container>
    )
}

export default DailyPlan;